"use strict";
exports.__esModule = true;
var angular = require("angular");
require('../comment-box-form.css');
var rangeFormController = /** @class */ (function () {
    function rangeFormController() {
    }
    return rangeFormController;
}());
var rangeFormDisplayController = /** @class */ (function () {
    function rangeFormDisplayController() {
        var _this = this;
        this.$onChanges = function () {
            var msg = [];
            if (_this.commentDecodedMsg) {
                var _a = _this.commentDecodedMsg, keysOrder = _a.keysOrder, form_1 = _a.form;
                (keysOrder || []).forEach(function (key) {
                    if (form_1[key].comment)
                        msg.push(key + ': ' + form_1[key].comment);
                });
            }
            _this.decodedMsg = msg;
        };
    }
    return rangeFormDisplayController;
}());
angular.module('smartorg.r6.cmpts.rangeForm', []).component("rangeForm", {
    template: require("./range-form.component.html"),
    controller: rangeFormController,
    bindings: {
        rowDisplayName: '<',
        currentComment: '='
    }
}).component("rangeFormDisplay", {
    template: require("./range-form.display.html"),
    controller: rangeFormDisplayController,
    bindings: {
        commentDecodedMsg: '<'
    }
});
module.exports = 'smartorg.r6.cmpts.rangeForm';
//# sourceMappingURL=range-form.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/input-screen/comment-box/range-form/range-form.component.js